// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3z5j-","legacyBtn":"MutateMid_legacyBtn__2Ez4p"};